/* ============================================================
   SPORTIVE CART — Urgency countdown timer
   Persists across cart re-renders via sessionStorage.
   ============================================================ */

(function () {
  'use strict';

  var SESSION_KEY = 'sportive_cart_timer_start';
  var DURATION_MS = 3 * 60 * 1000; // 3 minutes

  function getStartTime() {
    var stored = sessionStorage.getItem(SESSION_KEY);
    if (stored) return parseInt(stored, 10);
    var now = Date.now();
    sessionStorage.setItem(SESSION_KEY, now);
    return now;
  }

  function tick() {
    var el = document.getElementById('CartDrawer-Timer');
    if (!el) return;

    var start = getStartTime();
    var elapsed = Date.now() - start;
    var remaining = DURATION_MS - elapsed;

    if (remaining <= 0) {
      sessionStorage.setItem(SESSION_KEY, Date.now());
      remaining = DURATION_MS;
    }

    el.textContent = Math.floor(remaining / 1000);

    var bar = document.getElementById('CartDrawer-UrgencyBar');
    if (bar) {
      bar.classList.remove('sportive-urgency-bar--warn', 'sportive-urgency-bar--urgent');
      if (remaining <= 30000) {
        bar.classList.add('sportive-urgency-bar--urgent');
      } else if (remaining <= 60000) {
        bar.classList.add('sportive-urgency-bar--warn');
      }
    }
  }

  function initTimer() {
    getStartTime();
    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', initTimer);
})();

// Buy Now — add current variant to cart then go straight to checkout
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.sportive-buy-now');
  if (!btn) return;

  var form = btn.closest('form');
  if (!form) return;

  var variantInput = form.querySelector('input[name="id"]');
  if (!variantInput || variantInput.disabled) return;

  btn.disabled = true;
  btn.textContent = 'Loading…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
  })
  .then(function () {
    window.location.href = '/checkout';
  })
  .catch(function () {
    btn.disabled = false;
    btn.textContent = 'Buy Now';
  });
});
